// extracted by mini-css-extract-plugin
export default {"welcomeContent":"Welcome_welcomeContent__VrLby"};